"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _reactLoading = _interopRequireDefault(require("react-loading"));
var _config = require("../config");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var MessageLoading = function MessageLoading(props) {
  var classes = props.classes;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.messageRow, 'me'),
    style: {
      marginTop: 30
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.bubble,
    style: {
      padding: 0
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.message,
    style: {
      paddingLeft: 15
    }
  }, /*#__PURE__*/_react.default.createElement(_reactLoading.default, {
    type: 'bubbles',
    color: _config.MAIN_CHAT_COLOR,
    height: 50,
    width: 50
  }))));
};
var _default = MessageLoading;
exports.default = _default;